// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__14pEo","dragIcon":"SortableItem_dragIcon__aiQe8","disabled":"SortableItem_disabled__F3mZ6"};